// src/components/_v3/touristic-site/AppPromoBanner.jsx
import React from 'react';
import styled from 'styled-components';

// Lien de tracking OneLink (téléchargement app Henri Trip)
const ONELINK = 'https://henritrip.onelink.me/T2OV/khgtnwhx';

const AdSlotStyled = styled.a`
  position: relative;
  display: block;
  border-radius: ${props => props.theme.radius};
  overflow: hidden;
  box-shadow: ${props => props.theme.shadow};
  text-decoration: none;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

const AdLabelStyled = styled.span`
  position: absolute;
  top: .6rem;
  right: .7rem;
  z-index: 2;
  font-size: .6rem;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, .8);
  background: rgba(0, 0, 0, .4);
  border: 1px solid rgba(255, 255, 255, .35);
  border-radius: 4px;
  padding: .12rem .4rem;
`;

const AppPromoBanner = ({image, label = 'Publicité', alt = 'Application Henri Trip'}) => (
  <AdSlotStyled href={ONELINK} target="_blank" rel="noopener noreferrer sponsored">
    <AdLabelStyled>{label}</AdLabelStyled>
    <img src={image} alt={alt} loading="lazy" decoding="async" />
  </AdSlotStyled>
);

export default AppPromoBanner;
